import React from 'react';
import { WrenchIcon, ClipboardListIcon, HardHatIcon } from 'lucide-react';
import { ScreenProps } from '../../types/ptp';
import { SelectableChip } from '../ui/SelectableChip';
import { PrimaryButton } from '../ui/PrimaryButton';
const ENG_CONTROLS = ['Establish crane exclusion zone', 'Use tag lines to control load movement', 'Verify crane load capacity', 'Use certified lifting rigging'];
const ADMIN_CONTROLS = ['Designate trained signal person', 'Conduct pre-lift meeting', 'Review lift plan', 'Restrict unauthorized personnel'];
const PPE_CONTROLS = ['Hard hat', 'High visibility vest', 'Steel toe boots', 'Work gloves'];
export function ControlMeasuresScreen({
  data,
  updateData,
  onNext
}: ScreenProps) {
  const handleToggle = (category: 'engineeringControls' | 'adminControls' | 'ppeControls', option: string) => {
    const current = data[category];
    const updated = current.includes(option) ? current.filter(item => item !== option) : [...current, option];
    updateData({
      [category]: updated
    });
  };
  return <div className="flex flex-col h-full" data-id="element-146">
      <div className="mb-6" data-id="element-147">
        <h2 className="text-2xl font-bold text-white mb-2" data-id="element-148">Risk Controls</h2>
        <p className="text-slate-400" data-id="element-149">
          Select control measures to reduce risk.
        </p>
      </div>

      <div className="flex-1 overflow-y-auto pb-6 space-y-8 -mx-2 px-2" data-id="element-150">
        <section data-id="element-151">
          <div className="flex items-center gap-2 mb-3" data-id="element-152">
            <WrenchIcon className="w-5 h-5 text-yellow-500" data-id="element-153" />
            <h3 className="text-sm font-semibold text-slate-300 uppercase tracking-wider" data-id="element-154">
              Engineering Controls
            </h3>
          </div>
          <div className="space-y-2" data-id="element-155">
            {ENG_CONTROLS.map(option => <SelectableChip key={option} label={option} selected={data.engineeringControls.includes(option)} onToggle={() => handleToggle('engineeringControls', option)} data-id="element-156" />)}
          </div>
        </section>

        <section data-id="element-157">
          <div className="flex items-center gap-2 mb-3" data-id="element-158">
            <ClipboardListIcon className="w-5 h-5 text-yellow-500" data-id="element-159" />
            <h3 className="text-sm font-semibold text-slate-300 uppercase tracking-wider" data-id="element-160">
              Administrative Controls
            </h3>
          </div>
          <div className="space-y-2" data-id="element-161">
            {ADMIN_CONTROLS.map(option => <SelectableChip key={option} label={option} selected={data.adminControls.includes(option)} onToggle={() => handleToggle('adminControls', option)} data-id="element-162" />)}
          </div>
        </section>

        <section data-id="element-163">
          <div className="flex items-center gap-2 mb-3" data-id="element-164">
            <HardHatIcon className="w-5 h-5 text-yellow-500" data-id="element-165" />
            <h3 className="text-sm font-semibold text-slate-300 uppercase tracking-wider" data-id="element-166">
              Personal Protective Equipment
            </h3>
          </div>
          <div className="space-y-2" data-id="element-167">
            {PPE_CONTROLS.map(option => <SelectableChip key={option} label={option} selected={data.ppeControls.includes(option)} onToggle={() => handleToggle('ppeControls', option)} data-id="element-168" />)}
          </div>
        </section>
      </div>

      <div className="pt-4 bg-slate-950" data-id="element-169">
        <PrimaryButton onClick={onNext} data-id="element-170">Continue</PrimaryButton>
      </div>
    </div>;
}